import * as React from 'react';
import { Panel, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Translate } from '../../../shared/LanguageService';
import { IOrder } from '../Entities';

interface IProps {
    order: IOrder;
}

interface IState {
    enableLink: boolean;
}

class UploadedOrderRow extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            enableLink: true
        };

        this.onLinkClick = this.onLinkClick.bind(this);
    }

    onLinkClick() {
        this.setState({ enableLink: false } as IState);
    }

    getCompletedHeader(order: IOrder) {
        if (this.state.enableLink) {
            return (
                <Link
                    target="_blank"
                    onClick={this.onLinkClick}
                    className="goto-order-link btn btn-lg btn-warning"
                    to={`/orders/${order.id}/image`}
                >
                    <i className="material-icons">warning</i>{' '}
                    {Translate('photographer-uploads/page/order/complated/information')} -{' '}
                    {order.orderNumber}
                </Link>
            );
        } else {
            return (
                <Button className="goto-order-link btn btn-lg btn-warning" disabled={true}>
                    <i className="material-icons">warning</i>{' '}
                    {Translate('photographer-uploads/page/order/complated/information')} -{' '}
                    {order.orderNumber}
                </Button>
            );
        }
    }

    render() {
        return (
            <Panel className="goto-order-panel">
                <Panel.Heading>
                    <Panel.Title>{this.getCompletedHeader(this.props.order)}</Panel.Title>
                </Panel.Heading>
            </Panel>
        );
    }
}

export default UploadedOrderRow;
